import { Route, Wallet, CalendarCheck, Home } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const HomecareInfo = () => {
  const { site, openInquiry } = useSite();
  const s = site.settings;
  const homecare = site.categories.find((c) => c.slug === "homecare");
  const rows = [
    { icon: Route, text: s.homecare_radius_text, id: "radius" },
    { icon: Wallet, text: s.homecare_travel_text, id: "travel" },
    { icon: CalendarCheck, text: s.homecare_confirm_text, id: "confirm" },
  ].filter((r) => r.text);
  return (
    <section className="pb-12 sm:pb-16" data-testid="homecare-info-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="rounded-3xl bg-[#E6F3FA] border border-nanina-sky/40 p-5 sm:p-8 grid md:grid-cols-[.8fr_1.2fr] gap-5 items-center">
          <div>
            <span className="grid place-items-center h-11 w-11 rounded-xl bg-white text-nanina-green"><Home className="h-5 w-5" /></span>
            <h2 className="mt-3 text-xl sm:text-2xl font-extrabold tracking-tight text-nanina-green">Informasi Homecare</h2>
            <p className="mt-1 text-sm text-nanina-muted">Kami tidak menghitung jarak otomatis. Admin akan memastikan lokasi Anda masuk area layanan.</p>
            <button onClick={() => openInquiry(homecare ? homecare.name : "Homecare", "ya")} className="mt-4 rounded-full bg-nanina-green text-white text-sm font-semibold px-5 py-3 hover:bg-nanina-greendark transition-colors" data-testid="homecare-ask-button">
              Cek ketersediaan Homecare
            </button>
          </div>
          <ul className="space-y-2.5">
            {rows.map(({ icon: Icon, text, id }) => (
              <li key={id} className="flex gap-3 rounded-2xl bg-white p-4 text-sm text-nanina-green" data-testid={`homecare-${id}`}>
                <Icon className="h-5 w-5 shrink-0 text-nanina-fresh" />{text}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
